import React, { useState, useEffect } from 'react';
import {
  useSelector,
} from 'react-redux';

const Timer = ({ logout }) => {
  const expirationDate = useSelector((store) => store.authorizedState.get('expirationDate'));

  const calculateTimeLeft = () => {
    let timeLeft = {};

    if (!expirationDate) return timeLeft;

    const difference = new Date(expirationDate) - new Date();

    if (difference > 0) {
      timeLeft = {
        d: Math.floor(difference / (1000 * 60 * 60 * 24)),
        h: Math.floor((difference / (1000 * 60 * 60)) % 24),
        m: Math.floor((difference / 1000 / 60) % 60),
        s: Math.floor((difference / 1000) % 60),
      };
    } else {
      logout();
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval, index) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      // eslint-disable-next-line react/no-array-index-key
      <span key={index}>
        {timeLeft[interval]}
        {interval}
        {' '}
      </span>,
    );
  });

  return (
    timerComponents
  );
};

export default Timer;
